/**
 * Hand-written types matching the OpenAPI spec from `wanderfit-api`.
 *
 * We don't use Orval-generated types here because the venue-approval
 * endpoints are simple enough that hand-writing avoids the signal bug
 * (TD-05) and gives us full control over the shape.
 */

export const VenueType = {
  GYM: "GYM",
  SPA: "SPA",
  GYM_AND_SPA: "GYM_AND_SPA",
} as const;
export type VenueType = (typeof VenueType)[keyof typeof VenueType];

export const VenueStatus = {
  PENDING_APPROVAL: "PENDING_APPROVAL",
  ACTIVE: "ACTIVE",
  SUSPENDED: "SUSPENDED",
  REJECTED: "REJECTED",
  CHANGES_REQUESTED: "CHANGES_REQUESTED",
} as const;
export type VenueStatus = (typeof VenueStatus)[keyof typeof VenueStatus];

export interface VenueAmenity {
  readonly id: string;
  readonly category: string;
  readonly slug: string;
  readonly name: string;
}

export interface VenueHours {
  readonly dayOfWeek: number;
  readonly openTime: string;
  readonly closeTime: string;
  readonly isClosed: boolean;
}

export interface PendingVenue {
  readonly id: string;
  readonly name: string;
  readonly type: VenueType;
  readonly address: string;
  readonly city: string;
  readonly state: string;
  readonly latitude: number;
  readonly longitude: number;
  readonly description?: string;
  readonly photos: readonly string[];
  readonly amenities: readonly VenueAmenity[];
  readonly status: VenueStatus;
  readonly averageRating?: number;
  readonly reviewCount?: number;
  readonly hours?: readonly VenueHours[];
  readonly createdAt: string;
}

export interface ApproveVenueInput {
  readonly googleMapsRating: number;
}

export interface RejectVenueInput {
  readonly notes: string;
}

export interface RequestChangesInput {
  readonly message: string;
}

export interface ApprovalMetrics {
  readonly pending: number;
  readonly breachingSla: number;
  readonly avgHoursToDecision: number;
  readonly approvedCount: number;
  readonly rejectedCount: number;
  readonly period: "week" | "month";
}
